import React, { useMemo, useState } from 'react';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import { Grid } from "@mui/material";
import MDSnackbar from "components/MDSnackbar";
import MDButton from "components/MDButton";
import AccidentsTable from './table/accidentsTable';
import useAccidents from "./table/useAccidents";
import { downloadCsv, downloadJson } from "../utils/exportData";
import {
    accidentTypes,
    getAccidentOptionLabel,
    islandTypes,
    roadStatusVals,
    severityVals,
    weatherVals,
} from "layouts/dataimport/accidents/options";


const ShowAccidentList = () => {
        const { data: accidentsData = [], loading: exportLoading } = useAccidents("export");
        const accidentsCsvData = useMemo(
            () =>
                accidentsData.map((accident) => ({
                    ...accident,
                    severity: getAccidentOptionLabel(severityVals, accident.severity),
                    island: getAccidentOptionLabel(islandTypes, accident.island),
                    type_accident: getAccidentOptionLabel(accidentTypes, accident.type_accident),
                    weather: getAccidentOptionLabel(weatherVals, accident.weather),
                    road: getAccidentOptionLabel(roadStatusVals, accident.road),
                })),
            [accidentsData]
        );

        const [successSB, setSuccessSB] = useState(false);
        const [errorSB, setErrorSB] = useState(false);
        const openSuccessSB = () => setSuccessSB(true);
        const closeSuccessSB = () => setSuccessSB(false);
        const openErrorSB = () => setErrorSB(true);
        const closeErrorSB = () => setErrorSB(false);

        function bringSuccessNotification(){
            return (
                <MDSnackbar
                  color="success"
                  icon="check"
                  title="Succefully Deleted"
                  content="Your alert has been deleted"
                  dateTime={new Date().toLocaleTimeString()}
                  open={successSB}
                  onClose={closeSuccessSB}
                  close={closeSuccessSB}
                  bgWhite
                />
              );
        }
    
        function bringErrorNotification(){  
            return (
                <MDSnackbar
                  color="error"
                  icon="warning"
                  title="Error on deleting"
                  content="Your alert has not been deleted"
                  dateTime={new Date().toLocaleTimeString()}
                  open={errorSB}
                  onClose={closeErrorSB}
                  close={closeErrorSB}
                  bgWhite
                />
              );
        }


    return (
        <DashboardLayout>
            <Card style={{ marginTop: '3px', padding: '12px', height: '100%' }}>
                <Grid container item xs={12} md={12}>
                    <Grid item xs={12} md={12}>
                        <div className='rawContainerDiagrams'>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px", marginBottom: "12px", flexWrap: "wrap" }}>
                            <div className='diagrammHeadTitle' style={{color:"white"}}>Λίστα Ατυχημάτων</div>
                                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                                    <MDButton
                                      variant="outlined"
                                      color="info"
                                      disabled={exportLoading || accidentsData.length === 0}
                                      onClick={() => downloadCsv(accidentsCsvData, "accidents")}
                                      sx={{ "&.MuiButton-root": { textTransform: "none" } }}
                                    >
                                      Download CSV
                                    </MDButton>
                                    <MDButton
                                      variant="contained"
                                      color="info"
                                      disabled={exportLoading || accidentsData.length === 0}
                                      onClick={() => downloadJson(accidentsData, "accidents")}
                                      sx={{ "&.MuiButton-root": { textTransform: "none" } }}
                                    >
                                      Download JSON
                                    </MDButton>
                                </div>
                            </div>
                            <AccidentsTable setSuccessSB={setSuccessSB} setErrorSB={setErrorSB}  />
                        </div>
                    </Grid>
                </Grid>
            </Card>
            {successSB && bringSuccessNotification()}
            {errorSB && bringErrorNotification()}
        </DashboardLayout>
    );
};

export default ShowAccidentList;
